/**
 * Wraps an Office.js callback API in a promise that resolves to the value, or undefined when the call fails.
 */
export function callAsync<T>(
  invoke: (callback: (result: Office.AsyncResult<T>) => void) => void
): Promise<T | undefined> {
  return new Promise((resolve) => {
    invoke((result) => resolve(result.status === Office.AsyncResultStatus.Succeeded ? result.value : undefined));
  });
}
